import TableCell from "@mui/material/TableCell"
import TableRow from "@mui/material/TableRow"
import { styled } from "@mui/material/styles"
import PropTypes from "prop-types"

import { SortableHeaderCell } from "../../../common/components/tables/cells"

export const adminTableCellPaddingX = {
  xs: 1.25,
  sm: 1.5,
  md: 1.75,
  lg: 2,
}

export const adminTableCellPaddingYBody = {
  xs: 0.75,
  sm: 0.875,
  md: 1,
}

export const adminTableCellPaddingYHead = {
  xs: 0.625,
  sm: 0.75,
  md: 0.875,
}

export const adminTableEdgeInsetX = {
  xs: 1.5,
  sm: 2,
  md: 2.25,
  lg: 2.5,
}

export const adminTableBodyCellSx = {
  verticalAlign: "middle",
  fontSize: { xs: "0.8125rem", sm: "0.875rem" },
  lineHeight: 1.4,
  px: adminTableCellPaddingX,
  py: adminTableCellPaddingYBody,
}

export const adminTableHeadCellSx = {
  verticalAlign: "middle",
  fontSize: { xs: "0.65rem", sm: "0.6875rem", md: "0.72rem" },
  letterSpacing: { xs: "0.04em", sm: "0.05em", md: "0.06em" },
  fontWeight: 700,
  textTransform: "uppercase",
  lineHeight: 1.2,
  whiteSpace: "nowrap",
  px: adminTableCellPaddingX,
  py: adminTableCellPaddingYHead,
}

const AdminHeaderTableCellRoot = styled(TableCell)(({ theme }) => ({
  position: "sticky",
  top: 0,
  zIndex: 3,
  backgroundColor: "#eae8ed",
  borderBottom: `2px solid ${theme.palette.divider}`,
  color: theme.palette.text.primary,
  boxShadow: `inset 0 -1px 0 ${theme.palette.divider}`,
  ...adminTableHeadCellSx,
}))

export const AdminTableHeadRow = styled(TableRow)(() => ({
  height: "auto",
}))

export default function AdminHeaderTableCell({
  children,
  align,
  sx,
  title,
  width,
  minWidth,
  ...props
}) {
  const label = typeof children === "string" ? children : undefined

  return (
    <AdminHeaderTableCellRoot
      align={align}
      title={title || label}
      sx={{
        width,
        minWidth,
        ...sx,
      }}
      {...props}
    >
      {children}
    </AdminHeaderTableCellRoot>
  )
}

AdminHeaderTableCell.propTypes = {
  children: PropTypes.node,
  align: PropTypes.string,
  sx: PropTypes.object,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minWidth: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
  ]),
}

/**
 * Clickable sort header for admin lists. `query` is the useAdminPaginatedQuery
 * result; only pass columns the backend allows in `ordering`.
 */
export function AdminSortableHeaderCell({
  columnName,
  label,
  query,
  align,
  minWidth,
  width,
}) {
  return (
    <SortableHeaderCell
      HeaderCellComponent={AdminHeaderTableCell}
      columnName={columnName}
      label={label}
      sortColumn={query.sortColumn}
      sortDirection={query.sortDirection}
      onClick={query.onSortColumnChanged}
      props={{ align, minWidth, width, title: label }}
    />
  )
}

AdminSortableHeaderCell.propTypes = {
  columnName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  query: PropTypes.shape({
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    onSortColumnChanged: PropTypes.func.isRequired,
  }).isRequired,
  align: PropTypes.string,
  minWidth: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}
